import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Shield, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SupportAccessPage() {
  const [params] = useSearchParams();
  const action = params.get("action"); // approve or refuse
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!action || !token) {
      setStatus("error");
      setMessage("Lien invalide.");
      return;
    }
    const respond = async () => {
      try {
        const res = await axios.post(`${API}/api/event/support-access/${token}/respond`, { action });
        setMessage(res.data.message);
        setStatus("success");
      } catch (e) {
        setMessage(e.response?.data?.detail || "Erreur lors du traitement de la demande.");
        setStatus("error");
      }
    };
    respond();
  }, [action, token]);

  return (
    <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-[#0B1120] border border-[#1A2332] rounded-2xl p-8 text-center">
        {status === "loading" && (
          <>
            <Loader2 className="w-12 h-12 text-[#0099CC] animate-spin mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white">Traitement en cours...</h1>
          </>
        )}
        {status === "success" && action === "approve" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-[#10B981] mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">Assistance autorisee</h1>
            <p className="text-[#94A3B8] text-sm">{message}</p>
            <p className="text-[#64748b] text-xs mt-4">Vous pouvez revoquer cet acces a tout moment depuis votre espace.</p>
          </>
        )}
        {status === "success" && action === "refuse" && (
          <>
            <Shield className="w-12 h-12 text-[#F59E0B] mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">Demande refusee</h1>
            <p className="text-[#94A3B8] text-sm">{message}</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">Erreur</h1>
            <p className="text-[#94A3B8] text-sm">{message}</p>
          </>
        )}
        <Link to="/" className="inline-block mt-6 text-[#0099CC] hover:underline text-sm">
          Retour au site
        </Link>
      </div>
    </div>
  );
}
